export enum EType {
  All = 'All',
  New = 'New',
  Returning = 'Returning',
  AbandonedCheckout = 'AbandonedCheckout',
  Subscriber = 'Subscriber',
}
